import Data from 'data';

export const skills = {
  magicmissile: {
    info(rune, stats) {
      const mm = (stats.leg_mirrorball_p74 ? 2 : (stats.leg_mirrorball || 0)) + 1;
      const dps = {sum: true, "Damage": {speed: 1, fpa: 57.6, round: "up", count: stats.seasontheme_020 ? 10 : mm + (rune === "b" ? 2 : 0)}};
      if (stats.leg_theshameofdelsere) dps["Damage"].speed *= 1.5;
      if (stats.leg_fragmentofdestiny_p610) dps["Damage"].speed *= 1.5;
      if (rune === "c") dps["Burn Damage"] = {factor: Math.min(1, stats.info.aps * dps["Damage"].speed * (1 + mm))};
      switch (rune) {
      case "x": return {"DPS": dps, "Damage": {elem: "arc", coeff: 2.3}};
      case "a": return {"DPS": dps, "Damage": {elem: "arc", coeff: 3.25}};
      case "d": return {"DPS": dps, "Damage": {elem: "col", coeff: 1.75}};
      case "b": return {"DPS": dps, "Damage": {elem: "arc", coeff: 0.8}};
      case "e": return {"DPS": dps, "Damage": {elem: "arc", coeff: 2.85}};
      case "c": return {"DPS": dps, "Damage": {elem: "fir", coeff: 2.3}, "Burn Damage": {elem: "fir", coeff: 1.3, total: true}};
      // no default
      }
    },
  },
  shockpulse: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {count: 3, fpa: 57.142834, round: "up", speed: "(leg_theshameofdelsere?1.5:1)*(leg_fragmentofdestiny_p610?1.5:1)"}}},
      x: {"Damage": {elem: "lit", coeff: 1.94}},
      e: {"Damage": {elem: "col", coeff: 1.94}},
      a: {"Damage": {elem: "fir", coeff: 2.74}},
      c: {"DPS": {sum: true, "Damage": {fpa: 57.142834, round: "up", speed: 1}}, "Damage": {elem: "lit", coeff: 2.14}},
      d: {"Damage": {elem: "arc", coeff: 1.94}},
      b: {"Damage": {elem: "lit", coeff: 0.33}},
    },
  },
  spectralblade: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {count: 3, fpa: 56.25, round: "up", speed: "(leg_theshameofdelsere?1.5:1)*((leg_fragmentofdestiny||leg_fragmentofdestiny_p610)?1.5:1)"}}},
      x: {"Damage": {elem: "arc", coeff: 0.56}},
      a: {"Damage": {elem: "fir", coeff: 0.56}},
      d: {"Damage": {elem: "arc", coeff: 0.56}},
      b: {"Damage": {elem: "lit", coeff: 0.77}},
      e: {"Damage": {elem: "arc", coeff: 0.56}},
      c: {"Damage": {elem: "col", coeff: 0.56}},
    },
    active: true,
    params: [{rune: "a", name: "Stacks", min: 0, max: 30, val: 0}],
    buffs(rune, stats) {
      if (rune === "a") {
        return {dmgfir: this.params[0].val};
      }
    },
  },
  electrocute: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {speed: "(leg_theshameofdelsere?1.5:1)*(leg_fragmentofdestiny_p610?1.5:1)", fpa: 30}}},
      x: {"Damage": {elem: "lit", coeff: 0.69}},
      b: {"Damage": {elem: "lit", coeff: 0.69}},
      e: {"Damage": {elem: "fir", coeff: 0.69}, "Spark Damage": {elem: "fir", coeff: 0.44}},
      a: {"Damage": {elem: "lit", coeff: 1.4}},
      d: {"Damage": {elem: "lit", coeff: 0.69}},
      c: {"Damage": {elem: "lit", coeff: 1.55}},
    },
  },
  rayoffrost: {
    params: [{min: 0, max: 2, val: 2, name: "Channeled for", buffs: false}],
    info: {
      "*": {"Cost": {cost: 16, fpa: 30, rcr: {leg_hergbrashsbinding: "leg_hergbrashsbinding"}, bp: true}, "DPS": {elem: "col", aps: true, coeff: 4.3, addcoeff: [[4.05, "$1"]], total: true}},
      d: {"Cost": {cost: 11, fpa: 30, rcr: {leg_hergbrashsbinding: "leg_hergbrashsbinding"}, bp: true}},
      e: {"Patch Damage": {elem: "col", coeff: 16.25, total: true}},
      b: {"DPS": {elem: "col", aps: true, coeff: 3, addcoeff: [[2.2, "$1"]], total: true}},
    },
    active: true,
    buffs: {
      a: {dmgtaken: {elems: ["col"], percent: 15}},
    },
  },
  arcaneorb: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "arc", coeff: 4.35}}; break;
      case "a": res = {"Damage": {elem: "arc", coeff: 7}}; break;
      case "c": res = {"Damage": {elem: "arc", coeff: 2.65}}; break;
      case "b": res = {"Damage": {elem: "lit", coeff: 3.49}}; break;
      case "d": res = {"Damage": {elem: "fir", coeff: 2.21}, "Burn Damage": {elem: "fir", coeff: 7.34, total: true}}; break;
      case "e": res = {"Explosion Damage": {elem: "col", coeff: 9.50}, "Projectile Damage": {elem: "col", coeff: 6.35}, "Shard Damage": {elem: "col", coeff: 3.15}}; break;
      default: return;
      }
      const count = (stats.leg_unstablescepter || stats.leg_unstablescepter_p6 ? 2 : 1);
      res["DPS"] = {sum: true};
      if (rune !== "e") {
        res["DPS"]["Damage"] = {count: count, speed: 1, fpa: 57.857109, round: "up"};
        if (rune === "d") res["DPS"]["Burn Damage"] = {count: 1};
      } else {
        res["DPS"]["Shard Damage"] = {speed: 1, fpa: 57.857109, round: "up", nobp: true};
        res["DPS"]["Projectile Damage"] = {speed: 1, fpa: 57.857109, round: "up", nobp: true};
        res["DPS"]["Explosion Damage"] = {count: count, speed: 1, fpa: 57.857109, round: "up"};
      }
      return Object.assign({"Cost": {cost: 30}}, res);
    },
    active: false,
    params: [{rune: "b", min: 0, max: 15, val: 0, name: "Enemies Hit"}],
    buffs(rune, stats) {
      if (rune === "b") {
        return {dmgmul: {elems: ["lit"], percent: this.params[0].val * 2}};
      }
    },
  },
  arcanetorrent: {
    params: [{min: 0, max: 2, val: 2, name: "Channeled for", buffs: false}],
    info: {
      "*": {"Cost": {cost: 16, fpa: 20, rcr: {leg_hergbrashsbinding: "leg_hergbrashsbinding"}}},
      x: {"Tick Damage": {elem: "arc", coeff: 4, addcoeff: [[3.05, "$1"]], divide: {"Base Speed": 3}}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 20}}},
      a: {"Tick Damage": {elem: "fir", coeff: 4, addcoeff: [[3.05, "$1"]], divide: {"Base Speed": 3}}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 20}}},
      e: {"Cost": {cost: 16, fpa: 30, rcr: {leg_hergbrashsbinding: "leg_hergbrashsbinding"}}, "Tick Damage": {elem: "arc", coeff: 12.15, addcoeff: [[6.4, "$1"]], divide: {"Base Speed": 2}}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 30}}},
      c: {"Cost": {cost: 16, fpa: 40, rcr: {leg_hergbrashsbinding: "leg_hergbrashsbinding"}}, "Damage": {elem: "arc", coeff: 8.25}},
      d: {"Tick Damage": {elem: "lit", coeff: 4, addcoeff: [[3.05, "$1"]], divide: {"Base Speed": 3}}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 20}}, "Bolt Damage": {elem: "lit", coeff: 1.5}},
      b: {"Tick Damage": {elem: "arc", coeff: 4, addcoeff: [[3.05, "$1"]], divide: {"Base Speed": 3}}, "DPS": {sum: true, "Tick Damage": {speed: 1, fpa: 20}}, "Secondary Damage": {elem: "arc", coeff: 5.82}},
    },
    active: true,
    buffs(rune, stats) {
      if (rune === "a") {
        return {dmgred: 15 + 5 * this.params[0].val};
      }
    },
  },
  disintegrate: {
    params: [
      {min: 0, max: 2, val: 2, name: "Channeled for", buffs: false},
      {min: 0, max: 50, name: "Combustion", buffs: false, show(rune, stats) {
        return !!stats.set_firebird_4pc;
      }},
    ],
    info: {
      "*": {"Cost": {cost: 18, fpa: 20, rcr: {leg_hergbrashsbinding: "leg_hergbrashsbinding"}, bp: true}},
      x: {"DPS": {elem: "arc", aps: true, coeff: 3.9, addcoeff: [[2.5, "$1"]], total: true}},
      b: {"DPS": {elem: "fir", aps: true, coeff: 3.9, addcoeff: [[2.5, "$1"]], total: true}},
      e: {"DPS": {elem: "arc", aps: true, coeff: 3.9, addcoeff: [[2.5, "$1"]], total: true}, "Explosion Damage": {elem: "arc", coeff: 7.5}},
      c: {"DPS": {elem: "arc", aps: true, coeff: 4.35, addcoeff: [[3.4, "$1"]], total: true}},
      d: {"DPS": {elem: "arc", aps: true, coeff: 3.9, addcoeff: [[2.5, "$1"]], total: true}, "Secondary Damage": {elem: "arc", coeff: 1.15}},
      a: {"DPS": {elem: "arc", aps: true, coeff: 3.9, addcoeff: [[2.5, "$1"]], total: true}},
    },
    active: true,
    buffs: {
      a: {dmgtaken: {elems: ["arc"], percent: 15}},
    },
  },
  frostnova: {
    info: {
      "*": {"Cooldown": {cooldown: 11}},
      d: {"Cooldown": {cooldown: 7.5}},
      c: {"Damage": {elem: "col", coeff: 9.15, total: true}},
    },
    active: false,
    buffs: {
      e: {chc: 10},
      a: {dmgtaken: 33},
    },
  },
  diamondskin: {
    info: {
      "*": {"Cooldown": {cooldown: 15}},
      e: {"Damage": {elem: "arc", coeff: 8.63}},
    },
    active: false,
    buffs: {
      d: {rcrint: 9},
    },
  },
  slowtime: {
    info(rune, stats) {
      return {"Cooldown": {cooldown: (rune === "c" ? 12 : 15), cdr: (stats.leg_gestureoforpheus || stats.leg_gestureoforpheus_p2 || 0)}};
    },
    active: false,
    buffs(rune, stats) {
      const res = {};
      const allRunes = stats.leg_crownoftheprimus || stats.leg_crownoftheprimus_p74;
      if (rune === "a" || allRunes) res.dmgtaken = 15;
      if (rune === "e" || allRunes) res.ias = 10;
      if (stats.set_magnumopus_4pc) res.dmgred = 75;
      return res;
    },
  },
  teleport: {
    info(rune, stats) {
      const res = (stats.leg_aetherwalker ? {"Cost": {cost: 25}} : {"Cooldown": {cooldown: 11}});
      if (rune === "a") {
        res["Damage"] = {elem: "arc", coeff: 1.75};
      }
      if (stats.set_firebird_4pc && res["Cooldown"]) {
        res["Cooldown"].cdr = Data.skills.wizard.disintegrate.params[1].val * 2;
      }
      return res;
    },
    active: false,
    buffs: {
      c: {dmgred: 25},
    },
  },
  waveofforce: {
    info: {
      "*": {"Cost": {cost: 25}},
      x: {"Damage": {elem: "arc", coeff: 3.9}},
      a: {"Cooldown": {cooldown: 5}, "Damage": {elem: "arc", coeff: 3.9}},
      e: {"Damage": {elem: "arc", coeff: 3.9}},
      d: {"Damage": {elem: "arc", coeff: 3.9}},
      b: {"Damage": {elem: "lit", coeff: 3.9}},
      c: {"Damage": {elem: "fir", coeff: 4.75}},
    },
    active: false,
    params: [{rune: "d", min: 0, max: 20, val: 0, name: "Enemies Hit", inf: true}],
    buffs(rune, stats) {
      if (rune === "d") {
        return {dmgmul: {elems: ["arc"], percent: this.params[0].val * 4}};
      }
    },
  },
  energytwister: {
    params: [{rune: "c", min: 1, max: 3, name: "Charges", buffs: false}],
    info(rune, stats) {
      const res = {"Cost": {cost: 35}, "Damage": {elem: Data.skilltips.wizard.energytwister.elements[rune], coeff: 15.25, total: true}};
      switch (rune) {
      case "d": res["Cost"].cost = 25; break;
      case "e": res["Damage"].coeff = 8.35; break;
      case "c": res["Bolt Damage"] = {elem: "lit", addcoeff: [[1.96, "$1"]]}; break;
      // no default
      }
      if (rune === "b" || stats.leg_thetwistedsword_p610) {
        res["Large Tornado Damage"] = {elem: Data.skilltips.wizard.energytwister.elements[rune], coeff: 32, total: true};
      }
      return res;
    },
    active: true,
    buffs: {
      a: {dmgtaken: {elems: ["fir"], percent: 15}},
    },
  },
  hydra: {
    params: [
      {
        min: 1,
        max: stats => (stats.skills.hydra === "d" ? 1 : (stats.set_typhon_2pc ? 5 : 3)) * (stats.leg_serpentssparker || stats.leg_serpentssparker_p68 ? 2 : 1),
        step: stats => stats.set_typhon_4pc ? 1 : (stats.skills.hydra === "d" ? 1 : (stats.set_typhon_2pc ? 5 : 3)),
        name: "Hydras",
        buffs: false
      },
      {rune: "d", min: 0,max: 50, val: 5, name: "Distance", buffs: false},
    ],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "fir", pet: true, coeff: 1.65}}; break;
      case "e": res = {"Damage": {elem: "arc", pet: true, coeff: 2.05}}; break;
      case "b": res = {"Damage": {elem: "lit", pet: true, coeff: 2.55}}; break;
      case "c": res = {"Burn Damage": {elem: "fir", pet: true, coeff: 1.55, total: true}}; break;
      case "a": res = {"Damage": {elem: "col", pet: true, coeff: 2.55}}; break;
      case "d": res = {"Tick Damage": {elem: "fir", pet: true, coeff: 0.99, total: true}}; break;
      default: return;
      }
      if (rune === "b" && stats.passives.paralysis && stats.leg_manaldheal) {
        res["Manald Heal Damage"] = {elem: "lit", coeff: stats.leg_manaldheal * 0.01, pet: true, aps: true, manald: true};
      }
      if (rune !== "d") {
        res["DPS"] = {sum: true};
        res["DPS"][rune === "c" ? "Burn Damage" : "Damage"] = {pet: (rune === "a" ? 86 : 76.300583), area: false, speed: 1, count: this.params[0].val};
      } else {
        const duration = 5 - this.params[1].val * 1.8 / 50;
        res["Layer Damage"] = {sum: true, "Tick Damage": {count: Math.floor(duration / 0.3)}};
        res["DPS"] = {sum: true, "Layer Damage": {pet: 76.595741, area: false, speed: 1, count: this.params[0].val}};
      }
      return Object.assign({"Cost": {cost: 15}}, res);
    },
  },
  meteor: {
    params: [{rune: "d", min: "40*(1-0.01*rcr_ap)*(1-0.01*(leg_thegrandvizier_p6&&50||leg_thegrandvizier))-rcrint", max: "maxap", name: "Arcane Power", buffs: false},
             {min: 0, max: 10, val: 10, name: "Stacks", show(rune, stats) {
               return !!stats.leg_thesmolderingcore_p74;
             }}],
    active: true,
    activetip: "3 or fewer targets",
    activeshow(rune, stats) {
      return !!(stats.leg_nilfursboast || stats.leg_nilfursboast_p2 || stats.leg_nilfursboast_p6);
    },
    info(rune, stats) {
      let res = {
        x: {"Damage": {elem: "fir", coeff: 7.4, addcoeff: [2.35], total: 0}},
        e: {"Damage": {elem: "lit", coeff: 7.4, addcoeff: [2.35], total: 0}},
        d: {"Damage": {elem: "arc", coeff: 7.4, addcoeff: [[0.2, "$1-40*(1-0.01*rcr_ap)*(1-0.01*(leg_thegrandvizier_p6&&50||leg_thegrandvizier))+rcrint"], 2.35], total: 1}},
        c: {"Damage": {elem: "col", coeff: 7.4, addcoeff: [2.35], total: 0}},
        b: {"Damage": {elem: "fir", coeff: 2.77, addcoeff: [0.70], total: 0}},
        a: {"Cooldown": {cooldown: 15}, "Damage": {elem: "fir", coeff: 16.48, addcoeff: [6.25], total: 0}},
      }[rune];
      if (stats.leg_nilfursboast_p6) {
        res["Damage"].percent = {[Data.itemById.P61_Unique_Boots_01.name]: (this.active ? stats.leg_nilfursboast_p6 : 600)};
      } else if (stats.leg_nilfursboast_p2) {
        res["Damage"].percent = {[Data.itemById.P41_Unique_Boots_01.name]: (this.active ? stats.leg_nilfursboast_p2 : 200)};
      } else if (stats.leg_nilfursboast) {
        res["Damage"].percent = {[Data.itemById.P2_Unique_Boots_01.name]: (this.active ? stats.leg_nilfursboast : 100)};
      }
      const rcr = {};
      if (stats.leg_thegrandvizier_p6) rcr.leg_thegrandvizier_p6 = 50;
      else if (stats.leg_thegrandvizier) rcr.leg_thegrandvizier = stats.leg_thegrandvizier;
      if (rune === 'b' || stats.leg_mempooftwilight) {
        res["Total Damage"] = {sum: true, "Damage": {count: 7}};
        res["Average Damage"] = {sum: true, tip: "Small target gets hit by 2.5 meteors, on average", "Damage": {count: 2.5}};
      }
      res = Object.assign({"Cost": {cost: 40, rcr: rcr}}, res);
      return res;
    },
    buffs(rune, stats) {
      if (stats.leg_thesmolderingcore_p74 && this.params[1].val) {
        return {dmgmul: {skills: ["meteor"], percent: stats.leg_thesmolderingcore_p74 * this.params[1].val}};
      }
    },
  },
  blizzard: {
    info: {
      "*": {"Cost": {cost: 40}},
      x: {"Damage": {elem: "col", coeff: 10.75, total: true}, "DPS": {sum: true, "Damage": {divide: 6}}},
      c: {"Damage": {elem: "lit", coeff: 10.75, total: true}, "DPS": {sum: true, "Damage": {divide: 6}}},
      e: {"Damage": {elem: "col", coeff: 10.75, total: true}, "DPS": {sum: true, "Damage": {divide: 6}}},
      d: {"Damage": {elem: "col", coeff: 10.75, total: true}, "DPS": {sum: true, "Damage": {divide: 6}}, "Cost": {cost: 10}},
      b: {"Damage": {elem: "fir", coeff: 10.75, total: true}, "DPS": {sum: true, "Damage": {divide: 6}}},
      a: {"Damage": {elem: "col", coeff: 18.10, total: true}, "DPS": {sum: true, "Damage": {divide: 8}}},
    },
    active: true,
    buffs: {
      c: {dmgtaken: {elems: ["lit"], percent: 15}},
    },
  },
  icearmor: {
    info: {
      "*": {"Cost": {cost: 25}},
      a: {"Damage": {elem: "col", coeff: 1.89}},
      e: {"Damage": {elem: "col", coeff: 0.75}},
      c: {"DPS": {elem: "col", aps: true, coeff: 0.8, total: true}},
    },
    active: true,
    params: [{rune: "d", min: 0, max: 3, name: "Stacks"}],
    buffs(rune, stats) {
      const mdef = (stats.leg_haloofarlyse || 12);
      switch (rune) {
      case "x": return {meleedef: mdef};
      case "b": return {meleedef: mdef};
      case "d": return {meleedef: mdef, armor_percent: this.params[0].val * 20};
      case "a": return {meleedef: mdef};
      case "e": return {meleedef: mdef};
      case "c": return {meleedef: mdef};
      // no default
      }
    },
  },
  stormarmor: {
    info: {
      "*": {"Cost": {cost: 25}},
      x: {"Damage": {elem: "lit", coeff: 1.75}},
      c: {"Damage": {elem: "lit", coeff: 1.75}, "Thorns Damage": {elem: "lit", coeff: 1.89}},
      d: {"Damage": {elem: "lit", coeff: 1.75}},
      a: {"Damage": {elem: "lit", coeff: 3.15}},
      b: {"Damage": {elem: "lit", coeff: 1.75}},
      e: {"Damage": {elem: "lit", coeff: 1.75}, "Electrocute Damage": {elem: "lit", coeff: 4.25}},
    },
    active: true,
    buffs: {
      d: {rcrint: 3},
    },
  },
  magicweapon: {
    info: {
      "*": {"Cost": {cost: 25}},
      b: {"Zap Damage": {elem: "lit", coeff: 0.61}},
      a: {"Burn Damage": {elem: "fir", coeff: 3, total: true}},
    },
    active: true,
    buffs: {
      x: {damage: 10},
      b: {damage: 10},
      c: {damage: 20},
      d: {damage: 10},
      a: {damage: 10},
      e: {damage: 10},
    },
  },
  familiar: {
    info: {
      "*": {"Cost": {cost: 20}},
      x: {"Damage": {elem: "arc", coeff: 2.4}},
      a: {"Damage": {elem: "fir", coeff: 2.4}},
      c: {"Damage": {elem: "col", coeff: 2.4}},
      e: {"Damage": {elem: "arc", coeff: 2.4}},
      d: {"Damage": {elem: "arc", coeff: 2.4}},
      b: {"Damage": {elem: "arc", coeff: 2.4}},
    },
    active: true,
    buffs: {
      a: {damage: 10},
      d: {apregen: 4.5},
    },
  },
  energyarmor: {
    info: {
      "*": {"Cost": {cost: 25}},
    },
    active: true,
    buffs: {
      x: {armor_percent: 35, maxap: -20},
      d: {armor_percent: 35, maxap: -20},
      e: {armor_percent: 35, maxap: -20, chc: 5},
      b: {armor_percent: 35, maxap: 20},
      c: {armor_percent: 35, maxap: -20},
      a: {armor_percent: 35, maxap: -20, resist_percent: 25},
    },
  },
  explosiveblast: {
    info: {
      "*": {
        "Cost": {cost: 20},
        "Cooldown": {cooldown: 6},
        "Damage": null,
        "DPS": {sum: true, "Damage": {count: "(leg_wandofwoh||leg_wandofwoh_p6)?4:1", cd: 6, speed: 1, fpa: 56.249996, round: "up", nobp: true}},
      },
      x: {"Damage": {elem: "arc", coeff: 9.45}},
      d: {"Damage": {elem: "arc", coeff: 14.85}},
      c: {"Cooldown": {cooldown: 3}, "Damage": {elem: "lit", coeff: 9.45}, "DPS": {sum: true, "Damage": {count: "(leg_wandofwoh||leg_wandofwoh_p6)?4:1", cd: 3, speed: 1, fpa: 56.249996, round: "up", nobp: true}}},
      a: {"Damage": {elem: "fir", coeff: 9.09}},
      b: {"Damage": {elem: "col", coeff: 9.9}},
      e: {"Damage": {elem: "fir", coeff: 5.2}, "DPS": {sum: true, "Damage": {count: "(leg_wandofwoh||leg_wandofwoh_p6)?12:3", cd: 6, speed: 1, fpa: 56.249996, round: "up", nobp: true}}},
    },
  },
  mirrorimage: {
    info: {
      "*": {"Cooldown": {cooldown: 15}},
      e: {"Explosion Damage": {elem: "arc", coeff: 3.09}},
    },
  },
  archon: {
    info(rune, stats) {
      const res = {"Uptime": {duration: 20, cooldown: (rune === "d" || stats.set_vyr_2pc ? 100 : 120)}};
      let elem = Data.skilltips.wizard.archon.elements[rune];
      if (rune === "e" || stats.set_vyr_2pc) {
        res["Explosion Damage"] = {elem: elem, coeff: 36.8};
      }
      if (stats.set_vyr_2pc) {
        elem = stats.info.maxelem;
      }
      res["Arcane Strike Damage"] = {elem: elem, coeff: 7.9};
      res["Disintegration Wave DPS"] = {elem: elem, aps: true, coeff: 7.79, total: true};
      res["Arcane Blast Damage"] = {elem: elem, coeff: 6.04};
      res["Arcane Strike DPS"] = {sum: true, "Arcane Strike Damage": {speed: 1, fpa: 57.599954, round: "up"}};
      if (stats.set_chantodo_2pc) {
        res["Chantodo's DPS"] = {elem: "max", srcelem: Data.skilltips.wizard.archon.elements[rune], coeff: 40, aps: true, divide: {"Scaling": 1.75}};
        if (this.params[1].val) {
          res["Chantodo's DPS"].addcoeff = [[40, this.params[1].val]];
        }
      }
      if (rune === "a" || stats.set_vyr_2pc) {
        for (var k in res) {
          if (res[k].coeff) {
            res[k].percent = {};
            res[k].percent[this.runes.a] = 50;
          }
        }
      }
      return res;
    },
    active: false,
    params: [
      {min: "(leg_fazulasimprobablechain||leg_fazulasimprobablechain_p2)",
       max: "(leg_fazulasimprobablechain||leg_fazulasimprobablechain_p2)+50", val: "min", name: "Stacks", inf: true, buffs: false},
      {min: 0, max: 20, val: 20, name: "Chantodo's", buffs: false, show(rune, stats) {
        return !!stats.set_chantodo_2pc;
      }}
    ],
    buffs(rune, stats) {
      let stacks = this.params[0].val;
      if ((stats.leg_theswami || stats.leg_theswami_p3) && Data.itemaffixes.leg_theswami.active) {
        stacks += Data.itemaffixes.leg_theswami.params[0].val;
      }
      const res = {ccr: 100, dmgmul: {list: [30, 6 * stacks]}, armor_percent: 150, resist_percent: 150};
      if (stats.set_vyr_4pc) {
        res.ias = stacks * 1.0;
        res.armor_percent += stacks * 1.0;
        res.resist_percent += stacks * 1.0;
      }
      if (stats.set_vyr_6pc) {
        res.dmgred = 100 * (1 - Math.pow(0.9985, stacks));
        res.dmgmul.list[1] = stacks * 100;
      }
      return res;
    },
  },
  blackhole: {
    info: {
      "*": {"Cost": {cost: 20}, "Cooldown": {cooldown: 12}},
      x: {"Damage": {elem: "arc", coeff: 7, total: true}},
      a: {"Damage": {elem: "lit", coeff: 12.9, total: true}},
      e: {"Damage": {elem: "col", coeff: 7, total: true}},
      b: {"Damage": {elem: "arc", coeff: 7, total: true}},
      c: {"Damage": {elem: "fir", coeff: 7, total: true}, "Explosion Damage": {elem: "fir", coeff: 7.25}},
      d: {"Damage": {elem: "arc", coeff: 7, total: true}},
    },
    active: false,
    params: [{rune: "ed", min: 0, max: 25, val: 0, name: "Enemies Hit", inf: true}],
    buffs(rune, stats) {
      if (rune === "e") return {dmgcol: 3 * this.params[0].val};
      if (rune === "d") return {damage: 3 * this.params[0].val};
    },
  },
};

export const passives = {
  blur: {
    buffs: {dmgred: 17},
  },
  powerhungry: {
    active: true,
    buffs: {dmgmul: {pet: false, percent: 30}},
  },
  evocation: {
    buffs: {cdr: 20},
  },
  glasscannon: {
    buffs: {damage: 15, armor_percent: -10, resist_percent: -10},
  },
  prodigy: {
  },
  astralpresence: {
    buffs: {maxap: 20, apregen: 2.5},
  },
  illusionist: {
  },
  coldblooded: {
    active: true,
    buffs: {dmgtaken: 10},
  },
  conflagration: {
    active: true,
    buffs: {chctaken: 6},
  },
  paralysis: {
  },
  galvanizingward: {
  },
  temporalflux: {
  },
  dominance: {
  },
  arcanedynamo: {
    active: false,
    buffs: {dmgmul: {skills: ["rayoffrost", "arcaneorb", "arcanetorrent", "disintegrate", "hydra", "blackhole",
                              "waveofforce", "energytwister", "meteor", "blizzard", "explosiveblast"], percent: 60}},
  },
  unstableanomaly: {
  },
  unwaveringwill: {
    active: true,
    buffs: {armor_percent: 20, resist_percent: 20, damage: 10},
  },
  audacity: {
    active: true,
    buffs: {dmgmul: {pet: false, percent: 30}},
  },
  elementalexposure: {
    inactive: false,
    getElems(stats, type) {
      if (stats.charClass !== "wizard") {
        return {};
      }
      const elist = ["fir", "col", "lit", "arc"];
      var elems = {};
      if (type === "ee" || type === "tal2") {
        if (elist.includes(stats.info.mhelement)) {
          elems[stats.info.mhelement] = true;
        }
      }
      if (type === "ee") type = "tal2";
      let maxelem = "arc";
      for (const elem of elist) {
        if ((stats["dmg" + elem] || 0) > (stats["dmg" + maxelem] || 0)) {
          maxelem = elem;
        }
      }
      for (const skill in stats.skills) {
        const rune = stats.skills[skill];
        switch (skill) {
        case "frostnova":
          if (type === "tal2" || rune === "c") elems.col = true;
          break;
        case "diamondskin":
          if (rune === "e") elems.arc = true;
          break;
        case "slowtime":
          if (stats.set_magnumopus_4pc) elems[maxelem] = true;
          break;
        case "teleport":
          if (rune === "a") elems.arc = true;
          break;
        case "icearmor":
          if (type === "tal2" && rune === "c") elems.col = true;
          break;
        case "stormarmor":
          if (type === "tal2") elems.lit = true;
          break;
        case "magicweapon":
          if (type === "tal2") {
            if (rune === "b") elems.lit = true;
            if (rune === "a") elems.fir = true;
          }
          break;
        case "energyarmor":
          break;
        case "mirrorimage":
          if (type === "tal2" && rune === "e") elems.arc = true;
          break;
        case "familiar":
          if (type !== "tal2") break;
          // fallthrough
        default:
          if (skill === "archon" && stats.set_vyrs_2pc) elems[maxelem] = true;
          if (Data.skilltips.wizard[skill]) {
            const elem = Data.skilltips.wizard[skill].elements[rune];
            elems[elem] = true;
          }
        }
      }
      if (stats.gems.wreath && type === "tal2") {
        elems.lit = true;
      }
      return elems;
    },
    active: true,
    info(stats) {
      const elems = Data.passives.wizard.elementalexposure.getElems(stats, "ee");
      const list = Object.keys(elems).map(e => Data.elements[e]);
      if (list.length) {
        return {"Active Elements": list.join(", ")};
      }
    },
    params: [{min: 0, max(stats) {
      return Object.keys(Data.passives.wizard.elementalexposure.getElems(stats, "ee")).length;
    }, name: "Stacks"}],
    buffs(stats) {
      return {dmgmul: (stats.leg_primordialsoul ? 10 : 5) * this.params[0].val};
    },
  },
};

export const partybuffs = {
  rayoffrost: {
    runelist: "a",
  },
  disintegrate: {
    runelist: "a",
  },
  frostnova: {
    runelist: "a",
  },
  slowtime: {
    runelist: "ae",
    boxnames: ["Delsere's Magnum Opus (4pc)"],
    multiple: true,
    buffs(stats) {
      const buffs = {};
      if (this.runevals.a) buffs.damage = 15;
      if (this.runevals.e) buffs.ias = 10;
      if (this.boxvals[0]) buffs.dmgred = 30;
      return buffs;
    },
  },
  energytwister: {
    runelist: "a",
  },
  blizzard: {
    runelist: "c",
  },

  coldblooded: {},
  conflagration: {},
};

export const extraskills = {
  archon_arcanestrike: {
    required(stats) {
      return !!stats.skills.archon;
    },
  },
  archon_disintegrationwave: {
    required(stats) {
      return !!stats.skills.archon;
    },
  },
  archon_arcaneblast: {
    required(stats) {
      return !!stats.skills.archon;
    },
  },
  archon_slowtime: {
    required(stats) {
      return stats.skills.archon && (stats.skills.archon === "b" || stats.set_vyr_2pc);
    },
  },
  archon_teleport: {
    required(stats) {
      return stats.skills.archon && (stats.skills.archon === "c" || stats.set_vyr_2pc);
    },
  },
};
